
import React from 'react';
import ReclaimTest from './components/ReclaimTest';
import './App.css';

function App() {
  return (
    <div className="App">
      <ReclaimTest />
    </div>
  );
}

export default App;